import { defineStore } from 'pinia'
import { ref } from 'vue'
import MenuService from '@/services/menu.service'
import type { Prestador } from '@/types/menu.types'

export const useAuthStore = defineStore('auth', () => {
  const permissoes = ref<Set<string>>(new Set())
  const usuario = ref<{ login: string; nome: string } | null>(null)
  const prestador = ref<Prestador | null>(null)
  const menuConfig = ref<{ menuClass: string; profileMode: string; menuLayout: string } | null>(null)
  const carregado = ref(false)
  const temRoleCconecteNovo = ref(false)
  const urlLegado = ref('')

  async function carregarPermissoes() {
    if (carregado.value) return
    try {
      const config = await MenuService.getConfiguracaoUsuario()
      permissoes.value = new Set(config.permissoes ?? [])
      usuario.value = { login: config.login, nome: config.nome }
      prestador.value = config.dtoPrestador
      menuConfig.value = {
        menuClass: config.menuClass,
        profileMode: config.profileMode,
        menuLayout: config.menuLayout,
      }
      temRoleCconecteNovo.value = config.temRoleCconecteNovo ?? false
      urlLegado.value = config.urlLegado ?? ''
    } catch (error) {
      console.error('Erro ao carregar permissões:', error)
    } finally {
      carregado.value = true
    }
  }

  function temPermissao(nome: string): boolean {
    if (permissoes.value.size === 0) return import.meta.env.DEV
    return permissoes.value.has(nome)
  }

  function limpar() {
    permissoes.value = new Set()
    usuario.value = null
    prestador.value = null
    menuConfig.value = null
    carregado.value = false
    temRoleCconecteNovo.value = false
    urlLegado.value = ''
  }

  return { permissoes, usuario, prestador, menuConfig, carregado, temRoleCconecteNovo, urlLegado, carregarPermissoes, temPermissao, limpar }
})
